import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import cx from 'classnames'
import styles from './NotificationEntry.module.scss'
import {NotificationData} from "../../../types/NotificationData";
import IconButton from "../../../components/IconButton";
import Button from "../../../components/Button";
import {useNavigate} from "react-router-dom";

const NotificationEntry: React.FC<{ notification: NotificationData | null }> = ({
                                                                                    notification,
                                                                        }) => {
    const { t } = useTranslation(['common'])
    const [visible, setVisible] = useState<boolean>(true)
    const navigate = useNavigate()

    return notification &&
    visible ? (
        <div className={cx(styles['notification'], styles[`type-${notification?.type ?? 0}`])}>
            <div className={cx(styles['notification-message'])}>
                <div>
                    <b>{notification.title}</b>
                </div>
                {(notification.router_path && notification.router_path?.length > 0) &&
                    <Button
                        text={t('open')}
                        fn = {() => navigate(notification.router_path ?? '/')}
                        hierarchy={"secondary"}
                    />
                }
            </div>
            <IconButton
                icon={faClose}
                color={'000'}
                onClick={() => setVisible(false)}
            />
        </div>
    ) : null
}

export default NotificationEntry
